export const TRANSPARENCY_BREAKPOINT = 0.2;
export const PIKACHU_PRODUCTS = '215238eb-22a5-4c36-9e7b-e7c08025e04e_products';
//# sourceMappingURL=constants.js.map